<template>
	<ValidationObserver v-slot="{ valid, invalid, validated, passes, validate, handleSubmit, errors }" ref="observer">

		<div class="fill-height pa-5 pa-sm-10" v-if="AppStore.started_app" id="appreciation-page">
			<v-container class="fill-height d-flex align-center flex-row">
				<v-row class="">
					<v-card elevation="0" class="mx-auto pa-0 pa-sm-10 mb-5" rounded="xl">
						<v-col cols="12" class="text-h2 pt-5 pb-7 text-center my-auto" id="appreciation-title"
						       v-if="AppStore.data.configuration.display_appreciation_title">
							<span v-html="AppStore.data.configuration[AppStore.locale].appreciation_title"></span>
						</v-col>

						<v-col cols="12" class="">
							<div v-for="(question, questionIndex) in appreciation_questions_to_display"
							     :key="questionIndex" class="appreciation-questions">
								<divider-view v-if="question.format === 'divider'"></divider-view>
								<slider-view :class="{ 'd-none' : !question.mustBeShow }" :ref="'qi'+question.id"
								             v-if="question.format === 'slider'"
								             :rules="question.is_required ? { regex: /^[1-5]+$/ } : ''"
								             v-model="appreciation_questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></slider-view>
								<text-view :class="{ 'd-none' : !question.mustBeShow }" :ref="'qi'+question.id"
								           v-if="question.format === 'text'"
								           :rules="question.is_required ? 'required' : ''"
								           v-model="appreciation_questions_to_display[questionIndex]"
								           :questionIndex="questionIndex" :lang="AppStore.locale"></text-view>
								<textarea-view :class="{ 'd-none' : !question.mustBeShow }" :ref="'qi'+question.id"
								               v-if="question.format === 'textarea'"
								               :rules="question.is_required ? 'required' : ''"
								               v-model="appreciation_questions_to_display[questionIndex]"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></textarea-view>
								<select-view :class="{ 'd-none' : !question.mustBeShow }" :ref="'qi'+question.id"
								             v-if="question.format === 'select'"
								             :rules="question.is_required ? 'required' : ''"
								             v-model="appreciation_questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></select-view>
								<checkbox-view :class="{ 'd-none' : !question.mustBeShow }" :ref="'qi'+question.id"
								               v-if="question.format === 'checkbox'"
								               :rules="question.is_required ? 'required' : ''"
								               :color="AppStore.data.general.primary_color"
								               v-model="appreciation_questions_to_display[questionIndex]"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></checkbox-view>
								<radio-view :class="{ 'd-none' : !question.mustBeShow }" :ref="'qi'+question.id"
								            v-if="question.format === 'radio'"
								            :rules="question.is_required ? 'required' : ''"
								            :color="AppStore.data.general.primary_color"
								            v-model="appreciation_questions_to_display[questionIndex]"
								            :questionIndex="questionIndex" :lang="AppStore.locale"></radio-view>
								<switch-view :class="{ 'd-none' : !question.mustBeShow }" :ref="'qi'+question.id"
								             v-if="question.format === 'switch'"
								             :rules="question.is_required ? 'required' : ''"
								             :color="AppStore.data.general.primary_color"
								             v-model="appreciation_questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></switch-view>
							</div>
						</v-col>
						<v-col cols="12" class="text-center">
							<v-btn v-if="_.isEmpty(AppStore.rating.questions_answers)"
							       @click="passes(submit);"
							       @keypress.enter="navigate" role="link" rounded
							       outlined elevation="0"
							       :large="AppStore.data.general.button_size === 'large'"
							       :x-large="AppStore.data.general.button_size === 'x-large'"
							       :x-small="AppStore.data.general.button_size === 'x-small'"
							       :small="AppStore.data.general.button_size === 'small'"
							       :color="Helpers.getColor(AppStore.data.general.primary_color.hexa)"
							       class="revert-btn text-button"
							       :style="Helpers.getButtonSize(AppStore.data.general.button_size)"
							       v-html="AppStore.data.configuration[AppStore.locale].appreciation_retry_btn_text">
							</v-btn>
							<v-btn v-if="!_.isEmpty(AppStore.rating.questions_answers)" @click="passes(submit)" role="link"
							       rounded
							       elevation="0" dark
							       :large="AppStore.data.general.button_size === 'large'"
							       :x-large="AppStore.data.general.button_size === 'x-large'"
							       :x-small="AppStore.data.general.button_size === 'x-small'"
							       :small="AppStore.data.general.button_size === 'small'"
							       @keypress.enter="navigate"
							       :color="Helpers.getColor(AppStore.data.general.primary_color.hexa)"
							       class="text-button"
							       :style="Helpers.getButtonSize(AppStore.data.general.button_size)"
							       v-html="AppStore.data.configuration[AppStore.locale].appreciation_validate_btn_text">
							</v-btn>
						</v-col>
					</v-card>
				</v-row>
			</v-container>
		</div>
	</ValidationObserver>
</template>

<script>
import VTextAreaWithValidation from "../../../components/communs/inputs/VTextAreaWithValidation.vue";
import AppStore from "../../../stores/AppStore";
import _ from 'lodash';
import SliderView from '../../../components/communs/inputViewer/SliderView.vue'
import TextView from '../../../components/communs/inputViewer/TextView.vue'
import TextareaView from '../../../components/communs/inputViewer/TextareaView.vue'
import SelectView from '../../../components/communs/inputViewer/SelectView.vue'
import CheckboxView from '../../../components/communs/inputViewer/CheckboxView.vue'
import RadioView from '../../../components/communs/inputViewer/RadioView.vue'
import SwitchView from '../../../components/communs/inputViewer/SwitchView.vue'
import {EventBus} from "../../../services/Request";
import Helpers from "../../../services/Helpers";
import DividerView from "../../../components/communs/inputViewer/DividerView.vue";
import {ValidationObserver} from 'vee-validate';

export default {
	name: 'appreciation-view',

	components: {
		DividerView,
		VTextAreaWithValidation,
		ValidationObserver,
		SliderView,
		TextView,
		TextareaView,
		SelectView,
		CheckboxView,
		RadioView,
		SwitchView
	},

	props: {},

	data: () => ({
		AppStore,
		Helpers,
		outlinedTextArea: false,
		questions: [],
		appreciation_questions_to_display: []
	}),

	created() {
		EventBus.$on('update-question', (data) => {
			if (data.show) {
				// console.log(this.$refs['qi' + data.id])
				this.$refs['qi' + data.id][0].$el.classList.remove('d-none')
			} else {
				// console.log(this.$refs['qi' + data.id])
				this.$refs['qi' + data.id][0].$el.classList.add('d-none')
				delete AppStore.rating.questions_answers[data.id]
				this.$refs['qi' + data.id][0].sliderValue = 0
			}
		});
	},

	async mounted() {
		this.questions = []
		this.appreciation_questions_to_display = []
		await this.getBookmarkedQuestions()
		if (this.appreciation_questions_to_display.length < AppStore.data.configuration.appreciation_questions_to_display) {
			await this.getRandomQuestions();
		}
	},

	computed: {
		_() {
			return _;
		}
	},

	watch: {},

	methods: {
		getBookmarkedQuestions() {
			this.appreciation_questions_to_display = Object.assign([], AppStore.bookmarkedQuestions)
		},

		getRandomQuestions() {
			const max = AppStore.data.configuration.appreciation_questions_to_display - this.appreciation_questions_to_display.length
			this.questions = Object.assign([], AppStore.appreciation_questions)

			for (let i = 0; i < max; i++) {
				const randomQuestionIndex = Math.floor(Math.random() * (this.questions.length));
				this.appreciation_questions_to_display.push(this.questions[randomQuestionIndex]);
				this.questions.splice(randomQuestionIndex, 1)
			}
		},
		submit() {
			this.$router.push({name: 'tb-1-comment'})
		},
	}
};
</script>
<style>

</style>
